import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierDirectCustomerService,
  CarrierCustomerModel,
  CarrierCustomerRequest,
  PageModelCarrierCustomerModel,
  CarrierCustomerListRequest
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierDirectCustomerApiService {
  constructor(private apiService: CarrierDirectCustomerService) {}

  public addCarrierDirectCustomer(carrierId: string, body: CarrierCustomerRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierCustomerModel> {
    return this.apiService.carrierLCustomerAdd(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteCarrierDirectCustomer(carrierId: string, customerId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierLCustomerDelete(carrierId, customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierDirectCustomer(carrierId: string, customerId: string, body: CarrierCustomerRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierCustomerModel> {
    return this.apiService.carrierLCustomerEdit(carrierId, customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCarrierDirectCustomer(carrierId: string, customerId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierCustomerModel> {
    return this.apiService.carrierLCustomerGet(carrierId, customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listCarrierDirectCustomers(carrierId: string, body: CarrierCustomerListRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelCarrierCustomerModel> {
    return this.apiService.carrierLCustomerList(carrierId, body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
